import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  ADD_CHILDREN_HEALTH_PATH,
  ADD_CHILDREN_HEALTH_SUCCESS_PATH,
  CANCEL_CARE_RECIPIENT_PATH,
  UPDATE_CHILDREN_HEALTH_PATH,
  UPDATE_CHILDREN_HEALTH_SUCCESS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';

const LazyAddChildrenPage = lazy(() => import('@features/Caregivers/Children/CareRecipients/pages/AddChildrenPage'));

const LazyChildrenRequestSuccess = lazy(
  () => import('@features/Caregivers/Children/CareRecipients/components/ChildrenRequestSuccess')
);

const CancelRecipientPage = lazy(
  () => import('@features/Caregivers/FamilyFriends/CareRecipients/pages/CancelCareRecipientPage')
);

export const CHILDREN_HEALTH_ROUTES = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LazyAddChildrenPage />,
    displayTitle: () => 'Add Children Profiles',
    pageType: PageType.PRIVATE,
    path: ADD_CHILDREN_HEALTH_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LazyAddChildrenPage isUpdate />,
    displayTitle: () => 'Update Profile',
    pageType: PageType.PRIVATE,
    path: UPDATE_CHILDREN_HEALTH_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LazyChildrenRequestSuccess />,
    displayTitle: () => 'Add Child',
    pageType: PageType.PRIVATE,
    path: ADD_CHILDREN_HEALTH_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LazyChildrenRequestSuccess isUpdate />,
    displayTitle: () => 'Update Profile',
    pageType: PageType.PRIVATE,
    path: UPDATE_CHILDREN_HEALTH_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <CancelRecipientPage />,
    displayTitle: () => 'Family & Friends Details',
    pageType: PageType.PRIVATE,
    path: CANCEL_CARE_RECIPIENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
];
